import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import "./globals.css";
import App from "./App";

// Resolved at runtime from the host: import.meta.env.MODE is "production" in
// every build, so dev and prod events would be indistinguishable.
function sentryEnvironment(): string {
  switch (window.location.hostname) {
    case "glasstape.io":
      return "production";
    case "dev.glasstape.io":
      return "development";
    default:
      return "local";
  }
}

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: sentryEnvironment(),
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: 0.2,
    replaysOnErrorSampleRate: 1.0,
    replaysSessionSampleRate: 0,
  });
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
